// @flow

import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Grid, Button, TableContainer, Table, TableRow, TableBody, TableCell, Paper, TableHead } from '@material-ui/core/';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import APIDocscontent from '../../../data/cms/content/api-docs';
import APIContent from '../../../components/apiproducts/docs/content';
import SampleCode from '../../../components/apiproducts/docs/samplecode';
import XmlPath from '../../../components/docs/docs-version';
import NamingConvertion from '../../../components/apiproducts/docs/namingconvertion';
import Notes from '../../../components/apiproducts/docs/Notes';
import Data from '../../../components/apiproducts/docs/Data';
import InputParameter from '../../../components/apiproducts/docs/input';
import OutputParameter from '../../../components/apiproducts/docs/outputparameter';
import Constraints from '../../../components/apiproducts/docs/Constraints';
import Header from '../../../components/apiproducts/docs/header';
import Information from '../../../components/apiproducts/docs/information';
import ErrorCode from '../../../components/apiproducts/docs/errorcode';
import Supported from '../../../components/apiproducts/docs/supported';
import Output from '../../../components/apiproducts/docs/Output';
import BreadCrumb, {
    LookupBreadCrumb,
    Authentication,
    ListsBreadCrumb,
    NotificationBreadCrumb,
    BillingBreadCrumb,
    TaxCaddyBreadCrumb,
} from '../../../components/docs/breadcrum';
import './style.css';

function DocsCurentVerison(props) {
    const {
        PageName,
        BreadCumVersionLookupclick,
        BreadCumVersionActionclick,
        BreadCumVersionAuthclick,
        BreadCumCurVersionListsclick,
        onBreadCumCurrentnotificationclick,
        onBreadCumCurrentBillingClick,
        onBreadCumCurrentTaxCaddyClick,
    } = props;
    const page = PageName;
    const router = useHistory();
    const [GetAPIDocs, setAPIDocsContent] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const APIName = XmlPath(page);
    var Category = APIName.ApiType;
    const tryNowDisabledPages = [
        "currentver-pushengagementstatus",
        "currentver-drl",
        "currentver-pushdocumenttype",
        "currentver-documentsuploaded",
    ];

    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await APIDocscontent(APIName);
            setAPIDocsContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, [APIName]);

    const handleTryNow = () => {
        router.push(`/try-api/${GetAPIDocs?.ApiHelp?.Info?.TryAPI?.Link}/1`, { fromDocs: true, routeBackLink: `/docs-page/${page}` });
    };

    return (
        <Grid container className="docs-curverison">
            <Grid item sm={12} md={12} lg={12}>
                {!loading ? (
                    <>
                        <Grid className="docs-curverison-breadcumb">
                            {Category === 'Lookup Methods' ? (
                                <LookupBreadCrumb
                                    onBreadCumCurrentLookupclick={
                                        BreadCumVersionLookupclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Authentication' ? (
                                <Authentication
                                    onBreadCumCurrentAuthclick={
                                        BreadCumVersionAuthclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Lists' ? (
                                <ListsBreadCrumb
                                    onBreadCumCurrentListsclick={
                                        BreadCumCurVersionListsclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Action Methods' ? (
                                <BreadCrumb
                                    onBreadcumCurrentClick={
                                        BreadCumVersionActionclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Billing' ? (
                                <BillingBreadCrumb
                                    onBreadCumCurrentBillingClick={
                                        onBreadCumCurrentBillingClick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'TaxCaddy' ? (
                                <TaxCaddyBreadCrumb
                                    onBreadCumCurrentTaxCaddyClick={
                                        onBreadCumCurrentTaxCaddyClick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : (
                                <NotificationBreadCrumb
                                    onBreadCumCurrentnotificationclick={
                                        onBreadCumCurrentnotificationclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            )}
                        </Grid>
                        <Typography
                            component="div"
                            id={GetAPIDocs.ApiHelp.Info.RefName}
                        >
                            <Typography component="h3">
                                {GetAPIDocs.ApiHelp.Category}
                            </Typography>

                            <Typography component="h5">
                                {GetAPIDocs.ApiHelp.Info.Title}
                            </Typography>
                            <Button
                                onClick={handleTryNow}
                                className="try-now-link"
                                disabled={tryNowDisabledPages.find(disabledPage => disabledPage === page) ? true : false}
                            >
                                <ArrowRightAltIcon color={tryNowDisabledPages.find(disabledPage => disabledPage === page) ? "disabled" : "primary"} />
                                Try it Now
                            </Button>
                            <APIContent
                                Content={GetAPIDocs.ApiHelp.Info.Contents}
                            />
                        </Typography>

                        {GetAPIDocs.ApiHelp.Notes === '' ? (
                            ''
                        ) : (
                            <Notes
                                Content={GetAPIDocs.ApiHelp.Notes}
                            />
                        )}
                        {GetAPIDocs.ApiHelp.supported === '' ? (
                            ''
                        ) : (
                            <Supported
                                Content={GetAPIDocs.ApiHelp.supported}
                            />
                        )}
                        {GetAPIDocs.ApiHelp.NamingConvertion === '' ? (
                            ''
                        ) : (
                            <NamingConvertion
                                Content={GetAPIDocs.ApiHelp.NamingConvertion}
                            />
                        )}
                        {GetAPIDocs.ApiHelp.Endpoint.Title === '' ? (
                            ''
                        ) : (
                            <Typography
                                component="div"
                                id={GetAPIDocs.ApiHelp.Endpoint.RefName}
                            >
                                <Typography component="h5">
                                    {GetAPIDocs.ApiHelp.Endpoint.Title}
                                </Typography>
                                <Typography
                                    component="div"
                                    className="docs-curverison-code"
                                >
                                    {GetAPIDocs.ApiHelp.Endpoint.Content}
                                </Typography>
                            </Typography>
                        )}
                        {GetAPIDocs.ApiHelp.Header === '' ? (
                            ''
                        ) : (
                            <Typography
                                component="div"
                                id={GetAPIDocs.ApiHelp.Header.RefName}
                            >
                                <Header Content={GetAPIDocs.ApiHelp.Header} />

                                {GetAPIDocs.ApiHelp.TaxInfo === '' ? (
                                    ''
                                ) : (
                                    <APIContent
                                        Content={
                                            GetAPIDocs.ApiHelp.TaxInfo.Contents
                                        }
                                    />
                                )}
                                {GetAPIDocs.ApiHelp.LeadsInfo === '' ? (
                                    ''
                                ) : (
                                    <APIContent
                                        Content={
                                            GetAPIDocs.ApiHelp.LeadsInfo
                                                .Contents
                                        }
                                    />
                                )}

                                {GetAPIDocs.ApiHelp.Information === '' ? (
                                    ''
                                ) : (
                                    <Information
                                        Content={GetAPIDocs.ApiHelp.Information}
                                    />
                                )}
                            </Typography>
                        )}

                        {GetAPIDocs?.ApiHelp?.SupportMatrix?.Table ? (
                            <div>
                                <Typography component="h5">
                                    {GetAPIDocs?.ApiHelp?.SupportMatrix?.Title}
                                </Typography>
                                <Typography component="div" className="supported-subtitle">
                                    {GetAPIDocs?.ApiHelp?.SupportMatrix?.SubTitle}
                                </Typography>
                                <TableContainer component={Paper}>
                                    <Table sx={{ maxWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                {GetAPIDocs.ApiHelp.SupportMatrix.Table.Heading.Columns.map((title) => (
                                                    <TableCell align="left">
                                                        <Typography component="div" className="row-title">
                                                            {title}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="supported-table">
                                            {GetAPIDocs.ApiHelp.SupportMatrix.Table.Body.Columns.map((Row, index) => (
                                                <TableRow>
                                                    <TableCell key={index} align="left">
                                                        <Typography component="div" className="row-key">{Row.Key}</Typography>
                                                    </TableCell>
                                                    <TableCell key={index} align="left">
                                                        <Typography component="div" className="row-value">{Row.Value}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        ) : null}

                        <InputParameter
                            Content={GetAPIDocs.ApiHelp.InputParameters}
                        />

                        {GetAPIDocs.ApiHelp.OutputParameter === '' ? (
                            ''
                        ) : (
                            <OutputParameter
                                Content={GetAPIDocs.ApiHelp.OutputParameter}
                            />
                        )}

                        {GetAPIDocs.ApiHelp.Constraints === '' ? (
                            ''
                        ) : (
                            <Constraints
                                Content={GetAPIDocs.ApiHelp.Constraints}
                            />
                        )}
                        {GetAPIDocs.ApiHelp.Output === '' ? (
                            ''
                        ) : (
                            <Output
                                Content={GetAPIDocs.ApiHelp.Output}
                            />
                        )}
                        {/* {GetAPIDocs.ApiHelp.Constraints === '' ? (
                            ''
                        ) : (
                            <Constraints
                                Content={GetAPIDocs.ApiHelp.Constraints}
                            />
                        )} */}
                        {GetAPIDocs.ApiHelp.Data === '' ? (
                            ''
                        ) : (
                            <Data
                                Content={GetAPIDocs.ApiHelp.Data}
                            />
                        )}

                        {GetAPIDocs.ApiHelp.ErrorCode === '' ? (
                            ''
                        ) : (
                            <ErrorCode Content={GetAPIDocs.ApiHelp.ErrorCode} />
                        )}



                        {GetAPIDocs.ApiHelp.SampleCode === '' ? (
                            ''
                        ) : (
                            <>
                                <Typography
                                    component="div"
                                    id={GetAPIDocs.ApiHelp.SampleCode.RefName}
                                >
                                    <Typography
                                        id={
                                            GetAPIDocs.ApiHelp.SampleCode
                                                .RefName
                                        }
                                        component="h5"
                                    >
                                        Sample Code
                                    </Typography>

                                    <SampleCode
                                        Content={GetAPIDocs.ApiHelp.SampleCode}
                                    />
                                </Typography>
                            </>
                        )}
                    </>
                ) : (
                    ''
                )}
            </Grid>
        </Grid>
    );
}

export default DocsCurentVerison;
